<template>
	<div class="tuoshou">
		<div style="">
			<el-row>
				<el-col :span="24" >
					<el-table :data="tableData" row-key="key"  ref="singleTable"  :header-cell-style="{'background-color': '#e5e5e5'}" size="small" style="width: 100%">
							<el-table-column type="selection" width="55" />
							<el-table-column prop="key" label="行号" width="55" />
							<el-table-column prop="img" label="图片" width="55" show-overflow-tooltip>
								
							</el-table-column>
							<el-table-column prop="brand_name" label="品牌" width="90" show-overflow-tooltip />
							<el-table-column prop="name" label="品名" width="100" show-overflow-tooltip />
							<el-table-column prop="model" label="型号" width="120" show-overflow-tooltip />
							<el-table-column prop="order_no" label="订货号" width="120" show-overflow-tooltip />
							<el-table-column prop="price" label="列表价" width="80" align="right" header-align="left" show-overflow-tooltip />
							<el-table-column prop="discount" label="折扣" width="60" align="right" header-align="left" show-overflow-tooltip />
							<el-table-column prop="sur_num" label="数量" width="60" align="right" header-align="left" show-overflow-tooltip />
							<el-table-column prop="real_price" label="单价" width="80" align="right" header-align="left" show-overflow-tooltip />
							<el-table-column prop="real_money" label="金额" width="80" align="right" header-align="left" show-overflow-tooltip />
							
							
						</el-table>
					
				</el-col>
				
			</el-row>
			
		</div>

	</div>
</template>
<script>
export default {
	components: {},
	data() {

		return {
			tableData:[],
			form:{
				name:'',
			}

		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {

	},
	watch: {

	},
	methods: {

	}
}
</script>
<style lang="less" scoped>
</style>